/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { FormProvider } from "@simplicitycms/simplicity-forms";
import { Form } from "@simplicitycms/simplicity-forms";

const FormsComponent = (props) => {
    const component = props?.component;

    return (
        <FormProvider>
            <Form component={component} />
        </FormProvider>
    );
};

FormsComponent.displayName = "FormsComponent";

export { FormsComponent };
